// Mapping of the site
export const siteMap = {
    howToStart: [
        { path: "/open", text: "Opening a new business" },
        { path: "/upkeep", text: "Maintaining & upkeeping" },
        { path: "/expand", text: "Expanding business" },
        { path: "/visa", text: "Visa & licencing" },
        { path: "/china", text: "Business entering China" },
        { path: "/relocate", text: "Business leaving Hong Kong" }
    ],
    oftenUsed: [
        { path: "/incorporation", text: "HK company incorporation" },
        // { path: "/bank-account", text: "Open bank account" },
        // { path: "/registered-office", text: "Registered office" },
        { path: "/conference-room", text: "Book conference room" }
    ],
    resources: [
        // { path: "/resources", text: "Resources library" },
        // { path: "/subscribe", text: "Handpicked news" },
        { path: "/blog", text: "Blog" }
    ],
    whoWeAre: [{ path: "/about-us", text: "About our team" }]
};
